module.exports = __webpack_public_path__ + "img/folder-open.6aa9b141.svg";